export const portfolio = [
  {
    id: 32,
    title: "Two-Story Residence",
    subtitle: "Full repaint in San Bernardino",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/66eb774f-a606-414a-bdd0-3841de00de09_compressed_exterior.webp",
  },
  {
    id: 1,
    title: "Modern Home Exterior",
    subtitle: "Full exterior repaint in Riverside",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/0276758a-cb52-4831-993d-6265d3664c27_compressed_exterior.webp",
  },
  {
    id: 61,
    title: "Accent Wall Design",
    subtitle: "Feature walls in Menifee",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/75464b78-b94d-411d-be4a-d46b1c7523e9_compressed_interior18.webp",
  },
  {
    id: 2,
    title: "Living Room Transformation",
    subtitle: "Interior repaint in Corona",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ebb74c2e-f760-4fff-91ea-3b41d3b35f81_compressed_interior.webp",
  },
  {
    id: 3,
    title: "Office Building Facade",
    subtitle: "Commercial exterior in Orange County",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b95d6343-96b3-436f-9dac-ffb617cd3b0c_compressed_commercial.webp",
  },
  {
    id: 4,
    title: "Kitchen Refresh",
    subtitle: "Cabinet & wall repaint in San Bernardino",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/79d3b353-3faa-41b0-b274-b0451845b799_compressed_interior1.webp",
  },
  {
    id: 5,
    title: "Stucco Wall Repair",
    subtitle: "Crack repair and repaint in San Diego",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d4949f56-94f6-4763-b558-b53d20631e80_compressed_repair.webp",
  },
  {
    id: 6,
    title: "Bedroom Suite",
    subtitle: "Master bedroom in Los Angeles",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/c9306998-0cc2-413a-a643-355974143076_compressed_interior2.webp",
  },
  {
    id: 7,
    title: "Retail Storefront",
    subtitle: "Commercial paint in Riverside",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/30b6af09-c2fb-4a54-8506-1fbd64144c8b_compressed_commercial1.webp",
  },
  {
    id: 9,
    title: "Drywall Patching",
    subtitle: "Hole repair and texture match in Ontario",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/3e64e979-1a41-4b40-a8a0-56ba8a13938e_compressed_repair1.webp",
  },
  {
    id: 10,
    title: "Water Damage Restoration",
    subtitle: "Ceiling repair in Rancho Cucamonga",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ec2869c1-81d8-4fd7-a10e-3828e7bd0311_compressed_repair2.webp",
  },
  {
    id: 11,
    title: "Exterior Siding Fix",
    subtitle: "Wood replacement and paint in Murrieta",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/60623993-049b-4830-b68b-0a949f584142_compressed_repair3.webp",
  },
  {
    id: 12,
    title: "Peeling Paint Removal",
    subtitle: "Surface prep and recoat in Temecula",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/5b345058-4ca2-41e2-9f8f-e7504cd22af4_compressed_repair4.webp",
  },
  {
    id: 13,
    title: "Caulk & Seal Repair",
    subtitle: "Window and trim restoration in Hemet",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f46a49b9-8dc5-4466-8415-8cf382fe313f_compressed_repair5.webp",
  },
  {
    id: 14,
    title: "Baseboard Repair",
    subtitle: "Trim replacement and paint in Redlands",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f7ab3ec0-5817-469d-a26e-155f816b1b81_compressed_Repair6.webp",
  },
  {
    id: 15,
    title: "Concrete Crack Fill",
    subtitle: "Surface repair and sealing in Menifee",
    category: "Repair",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b58269bb-c045-4845-b086-36c230361575_compressed_Repair7.webp",
  },
  {
    id: 16,
    title: "Warehouse Interior Paint",
    subtitle: "Industrial facility in Ontario",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4a4f4eb6-f910-46ec-a209-728e817c0890_compressed_commercial2.webp",
  },
  {
    id: 17,
    title: "Medical Clinic Refresh",
    subtitle: "Interior repaint in Riverside",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6ceb1f96-417a-414b-ad95-3e0de7bd2ad4_compressed_commercial3.webp",
  },
  {
    id: 18,
    title: "Restaurant Exterior",
    subtitle: "Facade update in Corona",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/e09ad5fe-f034-45e9-9b08-fe899be2c025_compressed_commercial4.webp",
  },
  {
    id: 19,
    title: "Apartment Complex",
    subtitle: "Multi-unit exterior in San Bernardino",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/64c559c1-b7ae-4961-8284-29c84a0e7ce8_compressed_commercial5.webp",
  },
  {
    id: 20,
    title: "Gym & Fitness Center",
    subtitle: "Interior walls in Rancho Cucamonga",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/37f317c9-6541-4d84-85e6-56e25debaffd_compressed_commercial6.webp",
  },
  {
    id: 21,
    title: "School Hallway",
    subtitle: "Interior repaint in Moreno Valley",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/679fbaf1-2adc-4bda-ba67-dd6ba97b9bd4_compressed_commercial7.webp",
  },
  {
    id: 22,
    title: "Parking Structure",
    subtitle: "Concrete seal and paint in Temecula",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/e412feb3-3002-4cb7-8374-66a1cd346adb_compressed_commercial8.webp",
  },
  {
    id: 23,
    title: "Shopping Plaza",
    subtitle: "Exterior refresh in Murrieta",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/5cfd8ffa-80ad-413e-9f4f-1c2d5ea41132_compressed_commercial9.webp",
  },
  {
    id: 24,
    title: "Corporate Office Suite",
    subtitle: "Full interior repaint in Riverside",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/97bdc5b1-cc7e-4ca1-bec4-5c173fc1b85d_compressed_commercial10.webp",
  },
  {
    id: 25,
    title: "Auto Dealership",
    subtitle: "Showroom and exterior in Corona",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/64e64f19-ee1f-402a-8cc3-5254de95ffe4_compressed_commercial11.webp",
  },
  {
    id: 26,
    title: "Dental Office Interior",
    subtitle: "Clean modern repaint in Ontario",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/e5f565c2-2d49-48b7-a2ed-28f6614e5bd6_compressed_commercial12.webp",
  },
  {
    id: 27,
    title: "Church Exterior",
    subtitle: "Facade restoration in San Bernardino",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f7d4c2a0-ca4a-426c-8b97-6c05c757efda_compressed_commercial13.webp",
  },
  {
    id: 28,
    title: "Community Center",
    subtitle: "Multi-room repaint in Hemet",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9cf9a373-7cb7-4f66-9e05-3bcf7089a26b_compressed_commercial14.webp",
  },
  {
    id: 29,
    title: "Storage Facility",
    subtitle: "Unit doors and trim in Rancho Cucamonga",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b444e4b2-4c0b-4018-89d8-e0b58d26cd86_compressed_commercial15.webp",
  },
  {
    id: 30,
    title: "Hotel Lobby",
    subtitle: "Interior refresh in Temecula",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/7128c1d5-126a-48f7-a8aa-01f42ecf97f4_compressed_commercial16.webp",
  },
  {
    id: 31,
    title: "Bank Branch Exterior",
    subtitle: "Full repaint in Murrieta",
    category: "Commercial",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b0e2e5cd-bbac-4547-bf13-698af3a80af5_compressed_commercial17.webp",
  },

  {
    id: 33,
    title: "Ranch Style Home",
    subtitle: "Exterior refresh in Ontario",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/45fd6593-7cb3-40ad-af68-3cc4c0a2e513_compressed_exterior1.webp",
  },
  {
    id: 34,
    title: "Craftsman Bungalow",
    subtitle: "Trim and siding paint in Corona",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/64de3995-2223-43d3-8412-4d76dc5b1cdf_compressed_exterior2.webp",
  },
  {
    id: 35,
    title: "Mediterranean Villa",
    subtitle: "Stucco repaint in Rancho Cucamonga",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/2dd9aa79-dfa1-4202-9928-5aa7df85e002_compressed_exterior3.webp",
  },
  {
    id: 36,
    title: "Colonial Revival",
    subtitle: "Full exterior in Hemet",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/fbed8323-7c1f-41c4-9601-b87c94240c5f_compressed_exterior4.webp",
  },
  {
    id: 37,
    title: "Spanish Style Home",
    subtitle: "Facade repaint in Moreno Valley",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d15d1d09-6595-4e3a-aaa8-abd7b9458951_compressed_exterior5.webp",
  },
  {
    id: 38,
    title: "Contemporary Home",
    subtitle: "Exterior repaint in Temecula",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/c7cd4e0a-b5e0-40e1-8f9a-e8e42a8eb4dd_compressed_exterior6.webp",
  },
  {
    id: 39,
    title: "Victorian Restoration",
    subtitle: "Detailed trim work in Murrieta",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d5a66974-db29-45b9-afc3-7ab5e8a18b41_compressed_exterior7.webp",
  },
  {
    id: 40,
    title: "Tuscan Estate",
    subtitle: "Full exterior in Menifee",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/1fa0a902-c3a8-4396-b270-f5a4b58e7bb9_compressed_exterior8.webp",
  },
  {
    id: 41,
    title: "Farmhouse Revival",
    subtitle: "Full repaint in Riverside",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/70f0efb7-8888-43fe-89f7-a8df7f156e2e_compressed_exterior9.webp",
  },
  {
    id: 42,
    title: "Mid-Century Modern",
    subtitle: "Exterior refresh in Corona",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/eb4ae1c1-4802-484c-bf85-836aed56d859_compressed_exterior10.webp",
  },
  {
    id: 43,
    title: "Prairie Style Home",
    subtitle: "Trim and facade in Ontario",
    category: "Exterior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/94c09354-620f-4998-9d06-efba317ec19a_compressed_exterior11.webp",
  },

  {
    id: 46,
    title: "Dining Room Refresh",
    subtitle: "Wall repaint in San Bernardino",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/8bed64e1-3137-4f32-92dc-d20bd8ff6dcd_compressed_interior3.webp",
  },
  {
    id: 47,
    title: "Home Office Paint",
    subtitle: "Accent wall in Ontario",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ad0e9aa9-79f5-4a48-9d1e-6949838d1eb1_compressed_interior4.webp",
  },
  {
    id: 48,
    title: "Bathroom Makeover",
    subtitle: "Cabinet and walls in Corona",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/1fd4c627-a02b-42a8-afa2-3b76aad43a71_compressed_interior5.webp",
  },
  {
    id: 49,
    title: "Nursery Room Paint",
    subtitle: "Soft tones in Riverside",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/411c1ee2-507a-455b-9c96-4ac6e4f6add7_compressed_interior6.webp",
  },
  {
    id: 50,
    title: "Hallway Refresh",
    subtitle: "Trim and walls in Hemet",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f19d4ea4-fc7c-4e12-96a3-99ae4c678973_compressed_interior7.webp",
  },
  {
    id: 51,
    title: "Guest Room Update",
    subtitle: "Full repaint in Temecula",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9fa5dcb7-0347-407a-9525-1593e8417afa_compressed_interior8.webp",
  },
  {
    id: 52,
    title: "Family Room Redesign",
    subtitle: "Accent walls in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/3f275523-7135-449c-afd1-3aff0fd8d433_compressed_interior9.webp",
  },
  {
    id: 53,
    title: "Staircase Makeover",
    subtitle: "Railing and wall repaint in Murrieta",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/0000ce76-75d4-4149-b456-1178f8f5d388_compressed_interior10.webp",
  },
  {
    id: 54,
    title: "Laundry Room Refresh",
    subtitle: "Wall and cabinet paint in Redlands",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ec9611c9-e1be-4c0b-a7d1-a537f73a784d_compressed_interior11.webp",
  },
  {
    id: 55,
    title: "Basement Finish Paint",
    subtitle: "Full interior in Riverside",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/37796ca1-bfad-44a0-9f01-d81270108779_compressed_interior12.webp",
  },
  {
    id: 56,
    title: "Ceiling Restoration",
    subtitle: "Popcorn removal and paint in Corona",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d0cf8da4-53de-4df8-a56d-89d269021077_compressed_interior13.webp",
  },
  {
    id: 57,
    title: "Entryway Update",
    subtitle: "Door and trim repaint in Ontario",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/a8650eba-6ce5-4bb5-bbd9-9462a7e9b5e1_compressed_interior14.webp",
  },
  {
    id: 58,
    title: "Closet Refresh",
    subtitle: "Custom shelving paint in Temecula",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/2fde4b35-96cc-426a-8b71-413029979e47_compressed_interior15.webp",
  },
  {
    id: 59,
    title: "Sunroom Paint",
    subtitle: "Walls and ceiling in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/cc9c257a-9f65-433b-ae0f-35bf14e8641a_compressed_interior16.webp",
  },
  {
    id: 60,
    title: "Garage Interior Paint",
    subtitle: "Walls and floor in San Bernardino",
    category: "Interior",
    image:
      "https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/52e29dc6-464f-4efe-b66b-d485b2a51f94_compressed_interior17.webp",
  },

  {
    id: 62,
    title: "Commercial Office Hallway",
    subtitle: "Interior corridor repaint in Riverside",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/bd73afa8-b6ac-45ab-bd11-11c12a90b9f0_compressed_commercial24.webp",
  },
  {
    id: 63,
    title: "Retail Storefront Overhang",
    subtitle: "Exterior columns and awning in Corona",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/83499efa-512b-4d5f-91c5-d84c3c21bd51_compressed_commercial25.webp",
  },
  {
    id: 64,
    title: "Industrial Warehouse Exterior",
    subtitle: "Full facade repaint in Ontario",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9f45d055-0c70-4f53-b1e0-37ae97ffac81_compressed_commercial26.webp",
  },
  {
    id: 65,
    title: "Office Entry Wainscoting",
    subtitle: "Custom paneling and doors in San Bernardino",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f43266bf-46d1-45f8-af91-44bc2c3b935a_compressed_commercial18.webp",
  },
  {
    id: 66,
    title: "Conference Room Paneling",
    subtitle: "White board-and-batten walls in Rancho Cucamonga",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d1d65db8-ba63-4ad7-ad15-a4f3c082a2f3_compressed_commercial19.webp",
  },
  {
    id: 67,
    title: "Reception Area Wainscoting",
    subtitle: "Custom wall trim in Hemet",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/90d74961-3f30-43d0-a347-51643cfa98d6_compressed_commercial20.webp",
  },
  {
    id: 68,
    title: "Commercial Interior Hallway",
    subtitle: "Paneling and herringbone floors in Temecula",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/7784ff4b-7912-4301-96ea-e71163712cbd_compressed_commercial21.webp",
  },
  {
    id: 69,
    title: "Office Corridor Detail",
    subtitle: "White wainscoting and trim in Murrieta",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/0d44d981-432d-423a-9beb-5d8ae729e523_compressed_commercial22.webp",
  },
  {
    id: 70,
    title: "Modern Commercial Lounge",
    subtitle: "Black ceiling and gray walls in Moreno Valley",
    category: "Commercial",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f955018d-0705-40b7-880c-37296a2cb7b4_compressed_commercial23.webp",
  },
  {
    id: 71,
    title: "Mediterranean Home Exterior",
    subtitle: "Full repaint with palm tree landscaping in Riverside",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/01a9bb28-cf5f-4336-8861-88b5753dce36_compressed_exterior18.webp",
  },
  {
    id: 72,
    title: "Exterior Staircase Refinish",
    subtitle: "Gray textured paint on outdoor stairs in Corona",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/e2affce8-4145-4473-a077-9226291de724_compressed_exterior19.webp",
  },
  {
    id: 73,
    title: "Deck Walkway Paint",
    subtitle: "Gray deck and lattice railing in Ontario",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/a63b8f10-d829-4150-8a51-51caeda58183_compressed_exterior20.webp",
  },
  {
    id: 74,
    title: "Stucco Home Repaint",
    subtitle: "Two-story exterior transformation in San Bernardino",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/38e21455-2b2b-4a31-8c44-2917945a5f8e_compressed_exterior21.webp",
  },
  {
    id: 75,
    title: "Two-Story Stucco Refresh",
    subtitle: "Full exterior repaint with trim detail in Rancho Cucamonga",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/df42b131-6ae1-4477-95a6-85361ffbf6d2_compressed_exterior22.webp",
  },
  {
    id: 76,
    title: "Estate Home Exterior",
    subtitle: "Double garage stucco home in Hemet",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/912e9bd9-632c-4afb-b154-ae82dca9a36f_compressed_exterior23.webp",
  },
  {
    id: 77,
    title: "Townhouse Exterior Repaint",
    subtitle: "Multi-unit gray siding refresh in Moreno Valley",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/1a5a9ceb-41ca-49d0-b656-c48db01fdb49_compressed_exterior24.webp",
  },
  {
    id: 78,
    title: "Condo Facade Update",
    subtitle: "Blue-gray siding with white trim in Temecula",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6998741e-5a7c-407e-aa25-ba695d66dd06_compressed_exterior25.webp",
  },
  {
    id: 79,
    title: "Ranch Home Exterior",
    subtitle: "Single-story refresh with red front door in Murrieta",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/57732fa5-de76-4782-b1af-0c016167b5e3_compressed_exterior16.webp",
  },
  {
    id: 80,
    title: "Suburban Home Facade",
    subtitle: "Stucco and garage door repaint in Menifee",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/821549be-493e-4c41-868c-8d0a066e3e40_compressed_exterior17.webp",
  },
  {
    id: 81,
    title: "Modern Condo Exterior",
    subtitle: "Blue-gray siding refresh in Riverside",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/fb08d312-d2b5-47fe-8164-0cd0776adfd4_compressed_exterior34.webp",
  },
  {
    id: 82,
    title: "Townhouse Facade Update",
    subtitle: "Gray and white exterior repaint in Corona",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/3280d664-d9e5-4ca1-9121-30d68d2b910c_compressed_exterior35.webp",
  },
  {
    id: 83,
    title: "Two-Story Stucco Home",
    subtitle: "Full exterior repaint in Ontario",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/c3f08edf-7076-41b4-b760-3e1c1459eff4_compressed_exterior26.webp",
  },
  {
    id: 84,
    title: "Mediterranean Villa Exterior",
    subtitle: "Stucco and trim refresh in San Bernardino",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/fbeb9e66-3d47-4215-8abd-6d4b2c8f7a10_compressed_exterior27.webp",
  },
  {
    id: 85,
    title: "Ranch Style Home",
    subtitle: "Single-story exterior repaint in Rancho Cucamonga",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9c23692a-f690-4fac-8b2c-175941a2aaf7_compressed_exterior28.webp",
  },
  {
    id: 86,
    title: "Suburban Home Facade",
    subtitle: "Stucco and garage repaint in Hemet",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/34eaeb04-d4fd-4932-afa6-affd365eb770_compressed_exterior29.webp",
  },
  {
    id: 87,
    title: "Contemporary Home Exterior",
    subtitle: "Clean lines and trim detail in Temecula",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/fa46ce60-4a6c-4726-a94d-7a23d83436e0_compressed_exterior30.webp",
  },
  {
    id: 88,
    title: "Colonial Revival Exterior",
    subtitle: "White trim and stucco in Murrieta",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/1c83cc6d-29ea-4826-a2fc-a64bbe3d49c0_compressed_exterior31.webp",
  },
  {
    id: 89,
    title: "Spanish Style Home",
    subtitle: "Terracotta roof and stucco repaint in Moreno Valley",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/171e393e-5752-463e-9576-2157b6a29d65_compressed_exterior32.webp",
  },
  {
    id: 90,
    title: "Craftsman Bungalow",
    subtitle: "Porch and siding repaint in Redlands",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d6ba0a57-88db-4d4c-968e-d1698d14d115_compressed_exterior33.webp",
  },
  {
    id: 91,
    title: "Two-Story Siding Home",
    subtitle: "Gray siding and white trim repaint in Riverside",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/84d60cee-58a8-4deb-972b-f5e0cbe5ad71_compressed_exterior42.webp",
  },
  {
    id: 92,
    title: "Single-Story Refresh",
    subtitle: "White siding and trim repaint in Corona",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b35e4247-208d-4823-9aa2-6a7c11b8d21e_compressed_exterior43.webp",
  },
  {
    id: 93,
    title: "Front Entry Update",
    subtitle: "Siding and entry repaint in Ontario",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d9c3de89-3fa0-4790-b46f-0ae2a96b25cf_compressed_exterior44.webp",
  },
  {
    id: 94,
    title: "Porch and Trim Repaint",
    subtitle: "Tile roof home refresh in San Bernardino",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/65eda47a-e842-4756-9341-9818e6ac237b_compressed_exterior45.webp",
  },
  {
    id: 95,
    title: "Garage and Facade Refresh",
    subtitle: "Stucco and garage door repaint in Rancho Cucamonga",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d0d99a34-e3dd-4626-87ce-6912e169ce73_compressed_exterior36.webp",
  },
  {
    id: 96,
    title: "Side Stucco Wall",
    subtitle: "Exterior wall repaint in Hemet",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b085e1de-642d-4a28-a2d1-f8fa0717044e_compressed_exterior37.webp",
  },
  {
    id: 97,
    title: "Backyard Stucco Home",
    subtitle: "Two-story exterior repaint in Temecula",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/58eaaf93-bc13-4344-b57e-ec450ba425d3_compressed_exterior38.webp",
  },
  {
    id: 98,
    title: "Rear Exterior Update",
    subtitle: "Stucco and chimney refresh in Murrieta",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/36aa5374-f80e-4f07-bc67-51592ff92a9d_compressed_exterior39.webp",
  },
  {
    id: 99,
    title: "Shed Paint Prep",
    subtitle: "Metal shed repaint in Moreno Valley",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d5b51d9c-9390-4017-b9b9-1b56246fec0b_compressed_exterior40.webp",
  },
  {
    id: 100,
    title: "Shed Fresh Coat",
    subtitle: "Metal shed full repaint in Redlands",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/55b62344-777d-4517-aae9-004a59cea0af_compressed_exterior41.webp",
  },
  {
    id: 101,
    title: "Backyard Railing Refresh",
    subtitle: "White fence railing repaint in Riverside",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/21e63c81-2179-4f91-8248-da4cbb4d5fd8_compressed_exterior46.webp",
  },
  {
    id: 102,
    title: "Garden Wall Railing",
    subtitle: "White balustrade repaint in Corona",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b691295a-8da9-4936-b96b-763c5e5802d1_compressed_exterior47.webp",
  },
  {
    id: 103,
    title: "Patio Railing Update",
    subtitle: "Retaining wall railing repaint in Ontario",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4d561438-536e-499c-89e9-350e293b1cd6_compressed_exterior48.webp",
  },
  {
    id: 104,
    title: "Courtyard Fence Paint",
    subtitle: "White railing and trim refresh in San Bernardino",
    category: "Exterior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ccefd2c9-7477-4c83-ba70-be9cb4826485_compressed_exterior49.webp",
  },
  {
    id: 105,
    title: "Family Room Paint",
    subtitle: "Gray-blue walls and white trim in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ad80985b-2930-47b8-9a94-c0c45abb7704_compressed_interior27.webp",
  },
  {
    id: 106,
    title: "Bedroom with Shutters",
    subtitle: "Vaulted ceiling and gray walls in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/96de85b6-5d51-4211-ad61-6ac1634a8d5d_compressed_interior28.webp",
  },
  {
    id: 107,
    title: "Formal Living Paneling",
    subtitle: "White wall paneling and herringbone floors in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/57399775-8285-47b6-bfc6-4f21a1b08bf0_compressed_interior19.webp",
  },
  {
    id: 108,
    title: "Panel Wall with Doors",
    subtitle: "Custom molding and sliding doors in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/686b0704-e943-42d7-acda-c37fa54eafb5_compressed_interior20.webp",
  },
  {
    id: 109,
    title: "Kitchen Cabinet Refresh",
    subtitle: "Cabinet and wall repaint in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/cec5ce99-2c34-48c4-91db-3d6cb362e6d7_compressed_interior21.webp",
  },
  {
    id: 110,
    title: "Kitchen Island Update",
    subtitle: "Island and cabinet paint in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9e14a8a2-bd5b-42da-ab41-19cbc01fe5fa_compressed_interior22.webp",
  },
  {
    id: 111,
    title: "Kitchen Wall Refresh",
    subtitle: "Full kitchen repaint in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4d61e425-2339-4c3f-adf6-4676e22ea41b_compressed_interior23.webp",
  },
  {
    id: 112,
    title: "Arched Window Room",
    subtitle: "Tan walls and custom shutters in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d309f227-ed4b-404e-98f5-68f4b7ac664f_compressed_interior24.webp",
  },
  {
    id: 113,
    title: "Blue Bedroom Refresh",
    subtitle: "Gray-blue walls and shutters in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/bcb42701-9280-4aff-acba-57c65a709dd3_compressed_interior25.webp",
  },
  {
    id: 114,
    title: "Hallway Makeover",
    subtitle: "Gray hallway and archway paint in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/45250cd9-cb35-4697-ae6f-7d8309146930_compressed_interior26.webp",
  },
  {
    id: 115,
    title: "Kitchen with Dark Cabinets",
    subtitle: "Full kitchen repaint in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6cff34ae-4d1a-4e80-a833-cb0731468a0a_compressed_interior38.webp",
  },
  {
    id: 116,
    title: "Hallway and Door Refresh",
    subtitle: "White doors and gray walls in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/dc54c48f-95dc-42c7-b936-0e7ad2d70ae1_compressed_interior29.webp",
  },
  {
    id: 117,
    title: "Archway Trim Detail",
    subtitle: "Arched doorway repaint in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/61e6d727-879c-4da9-9bf3-e93652c6868d_compressed_interior30.webp",
  },
  {
    id: 118,
    title: "Farmhouse Kitchen Update",
    subtitle: "White cabinets and patterned tile in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6ded4d18-03de-4749-888e-28ed96923545_compressed_interior31.webp",
  },
  {
    id: 119,
    title: "White Cabinet Kitchen",
    subtitle: "Full cabinet and wall repaint in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/2cb8d0c4-cfac-4928-94ad-45a54af5af44_compressed_interior32.webp",
  },
  {
    id: 120,
    title: "Staircase Railing Refresh",
    subtitle: "White balusters and railing in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/a16c9426-dc52-4e33-9888-694934bcc817_compressed_interior33.webp",
  },
  {
    id: 121,
    title: "Upper Landing View",
    subtitle: "Staircase and hallway repaint in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/418136b7-66a9-4e44-8441-0b993a2d0088_compressed_interior34.webp",
  },
  {
    id: 122,
    title: "Staircase and Living Room",
    subtitle: "White railing and living room in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/978dd079-40d8-4d31-985e-5cdac0a08328_compressed_interior35.webp",
  },
  {
    id: 123,
    title: "Staircase with Fireplace",
    subtitle: "Railing and fireplace surround in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/695a2ba3-e054-4c50-a46c-dc8935d31609_compressed_interior36.webp",
  },
  {
    id: 124,
    title: "Kitchen with Wood Beam",
    subtitle: "Cabinet and ceiling beam repaint in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/1a8a7979-4ee8-4f55-acf8-c696a3c206f1_compressed_interior37.webp",
  },
  {
    id: 125,
    title: "Blue Bedroom Refresh",
    subtitle: "Full room repaint in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/5ce77ba0-0c87-4126-9fda-671c3138d324_compressed_interior43.webp",
  },
  {
    id: 126,
    title: "Door Trim Painting",
    subtitle: "Painter at work in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/36c584a4-3cfc-4118-a561-e36e639276b1_compressed_interior44.webp",
  },
  {
    id: 127,
    title: "Built-In Bar Paint",
    subtitle: "Custom cabinet repaint in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b9d0a439-5fb5-455c-8ec1-eac0b4f2aa9d_compressed_interior45.webp",
  },
  {
    id: 128,
    title: "Dining Room Finish",
    subtitle: "Neutral tones in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/bde96519-9e40-4b7a-85a7-208b7d897757_compressed_interior46.webp",
  },
  {
    id: 129,
    title: "Open Living Space",
    subtitle: "Light gray walls in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/0c2cafba-796c-4573-8199-bf8d6db96d3d_compressed_interior47.webp",
  },
  {
    id: 130,
    title: "Room Prep and Paint",
    subtitle: "Floor protection in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4361d830-f049-4014-918f-ae03b3eb0d95_compressed_interior48.webp",
  },
  {
    id: 131,
    title: "White Cabinet Kitchen",
    subtitle: "Cabinet refresh in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/5517b5c9-9d70-4ec1-8a59-7bdc97d1eff7_compressed_interior39.webp",
  },
  {
    id: 132,
    title: "Corner Kitchen View",
    subtitle: "Full kitchen repaint in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/855a3590-ce2d-48e2-a152-814b8f30cb32_compressed_interior40.webp",
  },
  {
    id: 133,
    title: "Cooktop Counter Detail",
    subtitle: "Cabinet and wall paint in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/bbe209f0-ca53-4db7-81e2-6b6b0970d817_compressed_interior41.webp",
  },
  {
    id: 134,
    title: "Kitchen Island Sink",
    subtitle: "Island and cabinet refresh in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/21839abf-9806-485a-9978-1be88dca746f_compressed_interior42.webp",
  },
  {
    id: 135,
    title: "Fresh White Bedroom",
    subtitle: "Full room repaint with trim in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9768526b-e401-4998-a879-80353c71f2c9_compressed_interior58.webp",
  },
  {
    id: 136,
    title: "Painter at Work",
    subtitle: "Wall painting in progress in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/5d436597-d716-41ad-be4c-ff3f0bf67028_compressed_interior49.webp",
  },
  {
    id: 137,
    title: "Room Prep and Painting",
    subtitle: "Floor protection and paint mixing in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/3a87d12f-dc98-431a-9498-1d0e91479d4b_compressed_interior50.webp",
  },
  {
    id: 138,
    title: "Hallway Entry Refresh",
    subtitle: "Gray walls and floor protection in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/7b1682d6-51cd-4809-83cc-7300cb463efc_compressed_interior51.webp",
  },
  {
    id: 139,
    title: "Living Room Prep",
    subtitle: "Frosted windows and floor covering in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/8ed1608b-156b-4322-98f5-80bebb4a5c07_compressed_interior52.webp",
  },
  {
    id: 140,
    title: "Open Living Space Paint",
    subtitle: "Sliding doors and chandelier area in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/9c003fe0-08ce-4ea7-8575-879c2f7b1202_compressed_interior53.webp",
  },
  {
    id: 141,
    title: "Bathroom Vanity Refresh",
    subtitle: "Cabinet and wall repaint in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6df11d49-1d0a-4dd5-af50-c8fd82a4fed8_compressed_interior54.webp",
  },
  {
    id: 142,
    title: "Mirrored Closet Bedroom",
    subtitle: "White walls and dark floors in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/df85afb9-2515-443e-8f2c-383e64c564a9_compressed_interior55.webp",
  },
  {
    id: 143,
    title: "Bright White Bedroom",
    subtitle: "Closet doors and window trim in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/8fc046b8-9ce8-458a-9231-5ce10d9b7a5a_compressed_interior56.webp",
  },
  {
    id: 144,
    title: "Clean Bedroom Finish",
    subtitle: "Full repaint with ceiling fan in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/29009c69-1b83-4085-bd50-ad0357c49b38_compressed_interior57.webp",
  },
  {
    id: 145,
    title: "Living Room Cabinet Prep",
    subtitle: "Wall repaint with crown molding in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/cc9d8fea-7d2a-4b9b-b163-2f085a3a50d2_compressed_interior66.webp",
  },
  {
    id: 146,
    title: "Hallway with Built-Ins",
    subtitle: "Gray walls and white trim in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/456dd86c-64f7-4b48-bfda-06f458e5b502_compressed_interior67.webp",
  },
  {
    id: 147,
    title: "Bathroom Gray Refresh",
    subtitle: "Vanity and wall repaint in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4a479b37-f335-4ad5-a493-100443c4d192_compressed_interior68.webp",
  },
  {
    id: 148,
    title: "White Hallway Passage",
    subtitle: "Trim and door repaint in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ed2a90a4-e8ac-4657-a161-aca894ee84df_compressed_interior59.webp",
  },
  {
    id: 149,
    title: "Dining Room Bright Finish",
    subtitle: "White walls and chandelier in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/dc7d5d0a-0193-48d2-bdc9-89d46d3adf69_compressed_interior60.webp",
  },
  {
    id: 150,
    title: "All-White Kitchen",
    subtitle: "Cabinet and wall repaint in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/09690fc0-1ca6-4ef3-8a3d-8a16627952fe_compressed_interior61.webp",
  },
  {
    id: 151,
    title: "Hallway to Bathroom",
    subtitle: "White trim and doors in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/224b0886-5f37-40c9-8788-c88ce84fac41_compressed_interior62.webp",
  },
  {
    id: 152,
    title: "Vaulted Ceiling Room",
    subtitle: "White walls and closet in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/7e2a8a21-c1e5-4b3d-a1e9-c951374aa458_compressed_interior63.webp",
  },
  {
    id: 153,
    title: "Bay Window Room",
    subtitle: "Gray walls with natural light in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/ed41d9bc-e313-4c03-8897-ff1581998778_compressed_interior64.webp",
  },
  {
    id: 154,
    title: "Walk-In Closet Paint",
    subtitle: "White walls and shelving in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f625bfc7-82e2-4eb7-804c-cf2ce497fe8c_compressed_interior65.webp",
  },
  {
    id: 155,
    title: "Upper Landing Railing",
    subtitle: "White balusters and newel posts in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/eefb4499-6408-486c-890f-1ae72ae48d88_compressed_interior75.webp",
  },
  {
    id: 156,
    title: "Navy Accent Wall Prep",
    subtitle: "Dark feature wall with shutter painting in Corona",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6735773b-be52-4ab3-ad83-7062226cb7aa_compressed_interior76.webp",
  },
  {
    id: 157,
    title: "Shiplap Ceiling Room",
    subtitle: "Navy walls and white doors in Ontario",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/8165f611-3842-410d-ab5d-f67189871281_compressed_interior77.webp",
  },
  {
    id: 158,
    title: "French Door Library",
    subtitle: "Built-ins and glass doors in San Bernardino",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/27098f98-77aa-46b5-9c30-4b1cd0a46921_compressed_interior78.webp",
  },
  {
    id: 159,
    title: "Black Window Trim Room",
    subtitle: "Neutral walls and dark frames in Rancho Cucamonga",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/d38493ea-0504-4124-9b1f-7776e9c11387_compressed_interior69.webp",
  },
  {
    id: 160,
    title: "Two-Tone Wall Design",
    subtitle: "Gray and white with black stripe in Hemet",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/6809e30b-ebbe-4806-8c8b-fd0da51c1ef6_compressed_interior70.webp",
  },
  {
    id: 161,
    title: "Garage Interior Paint",
    subtitle: "Gray and white walls with accent stripe in Temecula",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/97a6d870-dbc0-4caa-8fd5-625690bd86f7_compressed_interior71.webp",
  },
  {
    id: 162,
    title: "Open Room Refresh",
    subtitle: "Full interior repaint in Murrieta",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/f6a68976-d85a-41d2-a16e-0ea50aafd546_compressed_interior72.webp",
  },
  {
    id: 163,
    title: "Stairwell Gray Finish",
    subtitle: "Walls and carpeted stairs in Moreno Valley",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/c903e782-0122-4508-b0c0-afe72d928cba_compressed_interior73.webp",
  },
  {
    id: 164,
    title: "White Staircase Landing",
    subtitle: "Railing and chandelier detail in Redlands",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/689c263c-021f-493d-93b3-3c9eecbf1e90_compressed_interior74.webp",
  },
  {
    id: 165,
    title: "Fireplace Mantel and Accent Wall",
    subtitle: "Teal feature wall with mantel repaint in Riverside",
    category: "Interior",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/486d54b3-4d16-4629-aced-000741c668f3_compressed_interior79.webp",
  },
  {
    id: 166,
    title: "Entryway Ceiling Wash",
    subtitle: "Covered porch and ceiling cleaning in Riverside",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/282bb5c0-1f46-4fc1-8716-28a624a71c78_compressed_washer3.webp",
  },
  {
    id: 167,
    title: "Concrete Patio Cleaning",
    subtitle: "Sidewalk and patio surface wash in Corona",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/68e56e67-1da5-4701-bd23-b5f262d63cb7_compressed_washer4.webp",
  },
  {
    id: 168,
    title: "Patio Surface Refresh",
    subtitle: "Concrete pad and walkway cleaning in Ontario",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/b10aeb12-b929-4a3e-b622-74995901eb4c_compressed_washer5.webp",
  },
  {
    id: 169,
    title: "Second Story Exterior Wash",
    subtitle: "Stucco wall and window cleaning in San Bernardino",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/438ccc11-c3b6-49c0-aa47-f354d902f628_compressed_washer.webp",
  },
  {
    id: 170,
    title: "Upper Level Stucco Cleaning",
    subtitle: "Facade and window wash in Rancho Cucamonga",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/292a648f-c13b-475c-953c-afea44456279_compressed_washer1.webp",
  },
  {
    id: 171,
    title: "Porch Overhang Wash",
    subtitle: "Ceiling and column cleaning in Hemet",
    category: "Pressure Washing",
    image:
      "https://storage.helloreaddy.io/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/4d6b47de-4a2e-48b7-96cf-051040120054_compressed_washer2.webp",
  },
];